import { render } from "./d-dragon-tiger-bet-view.vue?vue&type=template&id=511d276a&scoped=true&ts=true"
import script from "./d-dragon-tiger-bet-view.vue?vue&type=script&lang=ts"
export * from "./d-dragon-tiger-bet-view.vue?vue&type=script&lang=ts"

import "./d-dragon-tiger-bet-view.vue?vue&type=style&index=0&id=511d276a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511d276a"]])

export default __exports__